import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { TranslocoCoreModule } from "@i18n";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { IMaskModule } from "angular-imask";
import { ReactiveFormsModule } from "@angular/forms";
import { VuiRangePickerComponent } from "./range-picker/range-picker.component";
import { VuiDatepickerComponent } from "./datepicker.component";
import { VuiCalendarHeaderComponent } from "./calendar-header/custom-calendar-header.component";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { DD_MM_YYYY_Format } from "./model";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
    declarations: [VuiRangePickerComponent, VuiDatepickerComponent, VuiCalendarHeaderComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        TranslocoCoreModule,
        IMaskModule,
        MatIconModule,
        MatButtonModule,
    ],
    exports: [VuiRangePickerComponent, VuiDatepickerComponent, VuiCalendarHeaderComponent],
    providers: [{ provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_Format }],
})
export class VuiDatepickerModule {}
